import React from 'react';
import ReactDOM from 'react-dom';

import UpshowLogger from '../../Logger';
import ReadinessLoading, { INTRO_MS } from './ReadinessLoading';
import ReadinessSuccess from './ReadinessSuccess';
import ReadinessBlock from './ReadinessBlock';
import ReadinessService from '../../services/readiness/ReadinessService';

// Mount ReadinessLoading, run all boot checks, unmount when done.
export function runReadinessLoading() {
    return new Promise((resolve) => {
        const container = document.createElement('div');
        container.id = 'readiness-loading-root';
        document.body.appendChild(container);

        let currentChecks = [];
        let isReady = false;

        function renderLoading() {
            ReactDOM.render(
                <ReadinessLoading checks={currentChecks} ready={isReady} />,
                container
            );
        }

        renderLoading(); // Initial render — shows intro splash

        // Delay check start until the intro splash finishes, so all 3 states are visible.
        setTimeout(() => {
            isReady = true;
            renderLoading(); // Transition to checking view before first onUpdate fires
            ReadinessService.runBootChecks((checks) => {
                currentChecks = checks;
                renderLoading();
            }).then((result) => {
                ReactDOM.unmountComponentAtNode(container);
                container.remove();
                resolve(result);
            }).catch((err) => {
                UpshowLogger.error('readiness', 'boot checks failed — skipping gate', err);
                ReactDOM.unmountComponentAtNode(container);
                container.remove();
                resolve(null);
            });
        }, INTRO_MS);
    });
}

// Mount success overlay (Ready) or block overlay (At-Risk / Not-Ready) after boot checks.
export function surfaceReadinessResult(result) {
    const container = document.createElement('div');
    const isReady = result.overallStatus === 'Ready';

    container.id = isReady ? 'readiness-success-root' : 'readiness-overlay-root';
    document.body.appendChild(container);

    const onDismiss = () => {
        ReactDOM.unmountComponentAtNode(container);
        container.remove();
    };

    if (isReady) {
        ReactDOM.render(
            <ReadinessSuccess onDismiss={onDismiss} />,
            container
        );
    } else {
        ReactDOM.render(
            <ReadinessBlock
                checks={Object.values(result.checks)}
                overallStatus={result.overallStatus}
                onDismiss={onDismiss}
            />,
            container
        );
    }
}
